import * as React from "react";

import {produce} from "immer";

import * as journal from "@client/features/journal";
import * as search from "@client/features/search";

import * as router from "@client/router";

import {useStage} from "@client/components/Stage";
import {server} from "@reactivated";

export const UpdateRecipeEntry = router.UpdateRecipeEntry.withHooks((props) => {
    const recipe = props.resolved.update_recipe;
    const entry = recipe.expanded_recipe.find(
        (entry) => entry.uuid == props.params.entryUUID,
    )!;

    const stage = useStage({
        entries: [entry],
        target: {type: "RECIPE", recipe: props.resolved.update_recipe},
    });

    return {
        stage,
        entry,
        recipe,
    };
})
    .withTab(
        {
            name: "macros",
            icon: "bullseye",
            title: "Macros",
            hasErrors: (props) => props.stage.hasErrors,
        },
        (props) => <>{props.stage.entries}</>,
    )
    .withTab(
        {
            name: "recipe",
            icon: "cutlery",
            title: "Recipe",
            guard: (props) => {
                if (props.stage.ingredients == false) {
                    return false;
                }
                return props;
            },
        },
        (props) => <>{props.stage.ingredients}</>,
    )
    .withActions((props) => [
        {
            icon: "remove",
            title: "Delete",
            onClick: () =>
                props.dispatch(
                    journal.confirmAndDeleteEntry(
                        {recipeId: props.recipe.id},
                        props.entry,
                    ),
                ),
        },
        {
            icon: "save",
            title: "Save",
            onClick: async () => {
                const payload = props.stage.validate();

                if (payload != null) {
                    const updatedIngredients = produce(
                        props.recipe.expanded_recipe,
                        (draft) => {
                            const sourceIndex = draft.findIndex(
                                (e) => e.uuid == props.entry.uuid,
                            );
                            draft[sourceIndex] = payload.single;
                        },
                    );

                    // We want the updated total macros, though this could be
                    // done with calculateMealMetrics or using the stage for the
                    // recipe. Otherwise the macros will be stale.
                    const updated = await server.journal.nutrition.update_recipe({
                        recipe_uuid: props.recipe.uuid,
                        entries: updatedIngredients,
                    });

                    if (updated.type === "success") {
                        void props.dispatch(search.loadSearch({reset: true}));
                        router.push(
                            "update_recipe.recipe",
                            {recipeId: updated.data.id},
                            {update_recipe: updated.data},
                        );
                    }
                }
            },
        },
    ])
    .withOptions(() => ({
        title: "Update Ingredient",
        back: "Recipe",
    }));
